import { useState, type FormEvent } from 'react';
import { ApiError, login } from '../lib/api';
import { Banner, Button, Field, Mark, input } from '../lib/ui';
import { t } from '../lib/i18n';

export function Login({ onDone }: { onDone: () => void }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await login(email, password);
      onDone();
    } catch (err) {
      // The API deliberately does not say which half was wrong, and neither does this.
      setError(err instanceof ApiError && err.status === 401
        ? t('E-Mail oder Passwort ist falsch.')
        : t('Anmeldung fehlgeschlagen. Läuft das Backend?'));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-sm space-y-4 rounded-[6px] border border-[var(--color-line)] bg-[var(--color-surface)] p-8">
        <div>
          <div className="mb-4 flex items-center gap-2">
            <Mark size={20} />
            <span className="text-[15px] font-semibold tracking-tight">Consent</span>
            <span className="text-[15px] text-[var(--color-muted)]">Console</span>
          </div>
          <p className="text-sm text-[var(--color-muted)]">{t('Bitte melden Sie sich an.')}</p>
        </div>
        {error && <Banner kind="error">{error}</Banner>}
        <Field label={t('E-Mail')}>
          <input className={input} type="email" autoComplete="username" required
            value={email} onChange={(e) => setEmail(e.target.value)} />
        </Field>
        <Field label={t('Passwort')}>
          <input className={input} type="password" autoComplete="current-password" required
            value={password} onChange={(e) => setPassword(e.target.value)} />
        </Field>
        <Button type="submit" disabled={busy}>{busy ? t('Anmelden …') : t('Anmelden')}</Button>
      </form>
    </div>
  );
}
